import * as Immutable from 'immutable';
import ProductPublishSummaryStore from './ProductPublish/ProductPublishSummaryStore';
import type { ProductPublishSummaryPayload } from './ProductPublish/ProductPublishSummaryStore';
import StoreProductListStore from './StoreProductListStore';
import type { StoreProductTypePayload } from './StoreProductListStore';

export interface UserStorePayload {
	id: number,
	slug: string,
	name: string,
	store_name?: string|null,
	store_admin_url?: string,
	details_loaded?: boolean,
	autopay?: boolean,
	payment_method?: string,
	billing_address?: number|null,
	autocancel?: boolean,
	autoship?: boolean,
	import_unsynced?: boolean,
	is_syncing_products?: boolean,
	is_adding_products?: number,
	product_publish_summary?: ProductPublishSummaryPayload,
	flagged?: boolean,
	error_slug?: string,
	is_missing_scope?: boolean,
	productTypes?: StoreProductTypePayload[],
}

export interface IUserStoreStore {
	id: number,
	slug: string,
	name: string,
	store_name: string|null,
	store_admin_url: string,
	details_loaded: boolean,
	autopay: boolean,
	payment_method: string,
	billing_address: number|null,
	autocancel: boolean,
	autoship: boolean,
	import_unsynced: boolean,
	is_syncing_products: boolean,
	is_adding_products: number,
	product_publish_summary: ProductPublishSummaryStore,
	flagged: boolean,
	error_slug: string,
	is_missing_scope: boolean,
	productTypes: Immutable.OrderedMap<string, string>,
	products: StoreProductListStore
}

const defaultStore = Immutable.Record<IUserStoreStore>({
	id: 0,
	slug: "",
	name: "",
	store_name: "",
	store_admin_url: "",
	details_loaded: false,
	autopay: false,
	payment_method: '',
	billing_address: null,
	autocancel: false,
	autoship: false,
	import_unsynced: false,
	is_syncing_products: false,
	is_adding_products: 0,
	product_publish_summary: new ProductPublishSummaryStore(),
	flagged: false,
	error_slug: '',
	is_missing_scope: false,
	productTypes: Immutable.OrderedMap<string, string>(),
	products: new StoreProductListStore()
});

export default class UserStoreStore extends defaultStore implements IUserStoreStore {}
